export default ['Respect', 'Integrity', 'Compassion', 'Healing', 'Teamwork', 'Excellence'];
